import { render, staticRenderFns } from "./mediateCaseDetail.vue?vue&type=template&id=3b557c28&scoped=true&"
import script from "./mediateCaseDetail.vue?vue&type=script&lang=js&"
export * from "./mediateCaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./mediateCaseDetail.vue?vue&type=style&index=0&id=3b557c28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b557c28",
  null
  
)

export default component.exports